import SHA256 from "crypto-js/sha256";

const attempts = new Map();
const prefix = "beauti:manual-voucher-email:";
const identifier = value => {
  const text = String(value ?? "");
  return /^\d+$/.test(text) ? text.replace(/^0+(?=\d)/, "") : text;
};

export const isVoucherEmailAccepted = payload => payload?.status === "accepted";

const storedKey = scope => {
  try {
    return sessionStorage.getItem(prefix + scope);
  } catch (_) {
    return null;
  }
};
const saveKey = (scope, key) => {
  try {
    if (key) {
      sessionStorage.setItem(prefix + scope, key);
    } else {
      sessionStorage.removeItem(prefix + scope);
    }
  } catch (_) {
    // Memory retains retry identity if browser storage is unavailable.
  }
};

export const sendVoucherEmailAttempt = ({ auth, endpoint, values, send }) => {
  const user = auth?.user || {};
  const rawUserId = user.id ?? user.user_id;
  // Match the backend intent, not ignored display fields or JS number/string
  // representation. The server resolves the authoritative stored recipient.
  // String normalization avoids rounding distinct database IDs via Number().
  const semantic = {
    voucher_to_id: identifier(values.voucher_to_id),
    client_id: identifier(values.client_id),
    code: typeof values.code === "string" ? values.code.trim() : values.code,
    voucher_sendmail: values.voucher_sendmail,
  };
  // Persist only an opaque digest and random key, never credentials or recipients.
  const scope = SHA256(JSON.stringify({
    endpoint,
    userId: identifier(rawUserId),
    salonId: identifier(user.salon?.id ?? user.salon_id),
    identityFallback: rawUserId == null ? user.auth_key : undefined,
    semantic,
  })).toString();
  let attempt = attempts.get(scope);
  if (!attempt) {
    const key = storedKey(scope) || (globalThis.crypto?.randomUUID
      ? globalThis.crypto.randomUUID()
      : `voucher-email-${Date.now()}-${Math.random().toString(36).slice(2)}`);
    attempt = { key, request: null };
    attempts.set(scope, attempt);
    saveKey(scope, key);
  }
  if (attempt.request) return attempt.request;
  let request;
  try {
    request = send(attempt.key);
  } catch (error) {
    return Promise.reject(error);
  }
  attempt.request = Promise.resolve(request).then(response => {
    if (response.status >= 200 && response.status < 300 && isVoucherEmailAccepted(response.data)) {
      if (attempts.get(scope) === attempt) attempts.delete(scope);
      saveKey(scope, null);
    }
    return response;
  }).finally(() => {
    attempt.request = null;
  });
  return attempt.request;
};
